import { GeneralApiResponse } from '../models/general-api-response';

export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Ocurrió un error inesperado'
): string => {
  // Handle error from HttpErrorResponse
  const err = error as any;
  const rawError = [
    err?.status,
    err?.statusText,
    err?.code,
    err?.message,
    err?.error?.status,
    err?.error?.statusText,
    err?.error?.code,
    err?.error?.message,
    err?.error?.apiError?.code,
    err?.error?.apiError?.messageDeveloper,
    err?.apiError?.code,
    err?.apiError?.messageDeveloper,
  ]
    .filter((value) => value !== undefined && value !== null)
    .join(' ')
    .toUpperCase();
  const isTechnicalServerError =
    /\b(?:UNAUTHORIZED|FORBIDDEN|INTERNAL SERVER ERROR|BAD GATEWAY|SERVICE UNAVAILABLE|GATEWAY TIMEOUT)\b/.test(
      rawError
    ) ||
    /\b(?:401|403|500|502|503|504)\b/.test(rawError);

  if (isTechnicalServerError) return fallback;

  if (err?.error) {
    return (
      err.error?.apiError?.messageUser || err.error?.messageUser || err.error?.message || fallback
    );
  }

  // Handle error from success = false
  const response = error as GeneralApiResponse;

  if (response?.success === false) {
    return response.apiError?.messageUser || response.messageUser || response.message || fallback;
  }

  return fallback;
};
